import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Uuri ja avasta! Iga päev palju põnevaid eripakkumisi.

  <span style="color:#85c1dc;">**FI:**</span>
  Tutustu ja löydä! Uusia ja mielenkiintoisia erikoistarjouksia joka päivä.

  <span style="color:#85c1dc;">**RU:**</span>
  Исследуй и открывай! Новые и интересные специальные предложения каждый день.
*/
/* @__NO_SIDE_EFFECTS__ */
const m51 = msg(
  mf`Uuri ja avasta! Iga päev palju põnevaid eripakkumisi.`,
  mf`Tutustu ja löydä! Uusia ja mielenkiintoisia erikoistarjouksia joka päivä.`,
  mf`Исследуй и открывай! Новые и интересные специальные предложения каждый день.`,
)

export { m51 as 'w.module.special_offers.title' }